module.exports = __webpack_public_path__ + "static/media/fresh-lenslatte.5958d5b8.png";